import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { TilesWrapper } from './style';
import Link from 'next/link';
import UseWindowSize from '../../hooks/helper/useWindowSize';
import { TilesContext } from '../../contexts/TilesContext';
import { UserContext } from '../../contexts/UserContext';
import { tagBuildBlueTile, tagFinalizeBlueTile } from '../../lib/events';
import dynamic from 'next/dynamic';
import { EditorState, ContentState, convertFromHTML } from 'draft-js'
import { EditorProps } from 'react-draft-wysiwyg'
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { TileDetailsContainer } from '../../styles/tileDetails-style';
import { Variation } from '../../models/product';
import { words } from './bluetile-helpers';
import { isMobileOnly as rddIsMobile } from 'react-device-detect';
import styled from 'styled-components';
interface Tile {
    kind: number;
}
interface Props {
    tiles: Tile[];
    setTiles: (value: React.SetStateAction<Tile[]>) => void;
    tileWords: string[];
    setTileWords: (value: React.SetStateAction<string[]>) => void;
    isReset: boolean;
    selectedTileType: string;
    setSelectedTileType: (value: React.SetStateAction<string>) => void;
    merchOptions: Variation[];
    merchandise: Variation;
    setMerchandise: (value: React.SetStateAction<Variation>) => void;
    snapImage: boolean;
    validation: string;
    setValidationError: (value: React.SetStateAction<string>) => void;
    handleFinalize: () => void;
}

const Editor = dynamic<EditorProps>(
    () => {
        return import("react-draft-wysiwyg").then(mod => mod.Editor);
    },
    { ssr: false }
);

export default function Tiles({ tiles, setTiles, selectedTileType, setSelectedTileType, tileWords, setTileWords, merchandise, setMerchandise, merchOptions, snapImage, validation, setValidationError, handleFinalize }: Props) {
    const [buildStarted, setBuildStarted] = useState(false);
    const [editor, setEditor] = useState(EditorState.createEmpty());
    // const editorRef = useRef(null);

    const [isMobile, setMobile] = useState<boolean>(false);

    useEffect(() => {
        setMobile(isMobile);
    }, [rddIsMobile]);

    useEffect(() => {
        setEditor(
            EditorState.createWithContent(
                ContentState.createFromText(tileWords?.join(''))
            )
        );
        setTextAreaWords(tileWords?.join(''));

    }, [])

    const updateTile = (index: number) => {
        setTiles(current =>
            current.map((obj, i) => {

                if (i === index) {
                    if (obj.kind == 9) {
                        return { ...obj, kind: 0 };
                    }
                    else {
                        return { ...obj, kind: obj.kind + 1 };
                    }
                }
                return obj;
            }),
        );
    };

    const charWidth = (value: string) => words?.[value.toUpperCase()]?.width ?? 5;

    const charStyle = (value: string) => {
        if (value == "\n") return "";
        else {
            switch (charWidth(value)) {
                case 2: return "two-tiles-container";
                case 3: return "three-tiles-container";
                case 4: return "four-tiles-container";
                case 5: return "five-tiles-container";
                case 6: return "six-tiles-container";
                case 7: return "seven-tiles-container";
                case 8: return "eight-tiles-container";
                default: return "tiles-container";
            }
        }
    };
    const handleTileClick = (index: number) => {
        updateTile(index);
        setBuildStarted(true);
    }
    const screenProps = UseWindowSize();
    const [isPatternAvailable, setIsPatternAvailable] = useState<boolean | null>(null);
    const [isNameAvailable, setIsNameAvailable] = useState<boolean | null>(null);
    const [loading, setLoading] = useState(false);
    const [lives, setLives] = useState([1]);
    const { exists, allowance, name, setName } = useContext(TilesContext);
    const { dbUser, firebaseSignOut, openLoginPopup } = useContext(UserContext);

    useEffect(() => {
        if (buildStarted) {
            tagBuildBlueTile();
        }
    }, [buildStarted])

    const checkAvailability = async () => {
        setLoading(true);
        const result = await exists();
        setIsPatternAvailable(!result[0]);
        setIsNameAvailable(!result[1]);
        tagFinalizeBlueTile(name, !result[0] && !result[1]);
        setLoading(false);
    }

    useEffect(() => {
        (async () => {
            const bluetileCredits = dbUser ? await allowance() : 1;
            setLives(prev => ([]));
            for (var i = 0; i < bluetileCredits; i++)
                setLives(prev => ([...prev, i]))
        })();
    }, [dbUser])

    useEffect(() => {
        if (!isMobile) {
            handleTileText();
        }
    }, [editor])

    const handleTileText = () => {
        const tileText = editor?.getCurrentContent()?.getPlainText();
        const tileCharacters = [];

        for (let i = 0; i < tileText?.length; i++) {
            tileCharacters.push(tileText?.charAt(i));
        }

        setTileWords(tileCharacters);
    }
    const handleTextArea = () => {
        const tileCharacters = [];
        for (let i = 0; i < textAreaWords?.length; i++) {
            tileCharacters.push(textAreaWords?.charAt(i));
        }
        setTileWords(tileCharacters);
    }
    const [textAreaWords, setTextAreaWords] = useState<string>();
    useEffect(() => {
        if (isMobile) {
            handleTextArea();
        }
    }, [textAreaWords]);

    const EditorWrapper = isMobile ? styled.div`
    .wrapper-class{
        border-bottom:none!important;
    }
    .editor-class{
        display:none
    }
    `: styled.div``;
    return (
        <>
            <div className='col-md-8 mx-auto'>
                <p className='text-center'>
                    Design own Blue Tile, a unique pattern that is your signature artwork. Share it with the world!<Link passHref href={'https://bluetileproject.com/about'}><a className='text-blue' target="_blank"> Learn more</a></Link>
                </p>
                {/* <Link href="/bluetile/gallery" passHref>
                    <p className='text-center'>Want some inspiration? <span className='text-blue cursor-pointer'>{`Visit the Gallery`}</span></p>
                </Link> */}
            </div>
            <div className='col-md-8 d-md-flex align-items-center justify-content-between mb-4 mx-auto'>
                <div className="col-lg-6">
                    <label className="col-form-label fw-bold ">
                        How do you want to build your Blue Tile?<span className='fw-bold'>*</span>
                    </label>
                    <p>Type a phrase or design your own pattern</p>
                </div>
                <div className='col-md-3 col-lg-6 mb-2 mb-md-0'>
                    <select className='form-select' onChange={(e) => setSelectedTileType(e.target.value)} defaultValue={selectedTileType}>
                        <option value={'shapes'}>Build my own Pattern</option>
                        <option value={'words'}>Type a Phrase</option>
                    </select>
                </div>
                {/* <div className="col-lg-6 col-md-8 col-sm-10 d-flex align-items-center justify-content-center justify-content-md-end p-2">
                    {dbUser?.handle ?? "Guest"}
                    {lives?.map((value) => <span key={value} className="ps-2"><FiHexagon size={15} color={'#1478dd'} /></span>)}
                    <span className={`ps-2 ${lives.length == 0 ? "text-error" : ""}`}>{lives.length} mints left</span>
                    {dbUser?.handle ? <span className="ps-2"><a className='text-blue cursor-pointer' onClick={() => firebaseSignOut()}>{" "}Sign out</a></span> : <span className="ps-2"><a className='text-blue cursor-pointer' onClick={() => openLoginPopup()}>{" "}Sign in</a></span>}
                </div> */}
            </div>
            <TilesWrapper className='col-12' style={!snapImage ? { overflowX: 'hidden' } : {}}>
                {selectedTileType == 'words' && <div className='col-12 col-md-10 col-lg-8 mx-md-auto mx-2'>
                    <div className='form-group row mb-4'>
                        <label className="col-form-label fw-bold ">Type your phrase:</label>
                        <div className='position-relative'>
                            <EditorWrapper>
                                <Editor
                                    // ref={editorRef} 
                                    editorState={editor}
                                    onEditorStateChange={setEditor}
                                    wrapperClassName="wrapper-class"
                                    editorClassName="editor-class"
                                    toolbarClassName="toolbar-class"
                                    autoCapitalize={'none'}
                                    autoComplete={'off'}
                                    autoCorrect={'off'}
                                    spellCheck={false}
                                    onChange={(e) => { isMobile ? setTextAreaWords(pre => pre + e?.blocks?.[0]?.text?.slice(0, 1)) : null }}
                                    toolbar={{
                                        options: ['inline', 'emoji'], inline: { options: [] }, emoji: {
                                            inDropdown: false,
                                            popupClassName: undefined, emojis: ['\u2764']
                                        }
                                    }} //'superscript', 'subscript'
                                />
                            </EditorWrapper>
                            <div className={`wrapper-class rdw-editor-wrapper ${isMobile ? 'd-block' : 'd-none'}`} style={{ transform: 'translateY(-5px)' }}>
                                <textarea value={textAreaWords} onChange={(e) => { setTextAreaWords(e?.target?.value); }} className='editor-class rdw-editor-main w-100 border-none outline-none' />
                            </div>
                        </div>
                    </div>
                </div>}
                {selectedTileType == 'shapes' ?
                    <div id='shape-tiles'>
                        <div className='tiles-container'>
                            {tiles?.map((item, index) => {
                                return <div key={`${index}`} className={`tile overflow-hidden ${item.kind <= 5 ? 'bg-white' : 'bg-blue'}`} onClick={
                                    () => {
                                        handleTileClick(index);
                                        setIsPatternAvailable(null);
                                    }
                                }>
                                    <div className={`${item.kind == 1 ? 'blue-tile'
                                        : item.kind == 2 ? 'blue-tile-top'
                                            : item.kind == 3 ? 'blue-tile-right'
                                                : item.kind == 4 ? 'blue-tile-bottom'
                                                    : item.kind == 5 ? 'blue-tile-left'
                                                        : item.kind == 6 ? 'v-white-tile-top'
                                                            : item.kind == 7 ? 'v-white-tile-right'
                                                                : item.kind == 8 ? 'v-white-tile-bottom'
                                                                    : item.kind == 9 ? 'v-white-tile-left'
                                                                        : 'white-tile'
                                        }`}>

                                    </div>

                                </div>
                            })}

                        </div>
                        {name ? <p className="text-center font-bold">{name}</p> : null}
                    </div> :
                    <div id='word-tiles' className={`position-relative col-12 col-md-8 `} >
                        <div className='d-flex flex-wrap w-100' >
                            {tileWords?.map((value, index) => <>
                                <div key={`${index}`} className={`${charStyle(value)} ${value == '\n' ? 'w-100 clear-left' : ''} border-left`}>
                                    {value != '\n' && words?.[value.toUpperCase()]?.coordinates?.map((item, index) => {
                                        return <div key={`${index}`} className={`tile overflow-hidden ${item <= 5 ? 'bg-white' : 'bg-blue'} `}>
                                            <div className={`${item == 1 ? 'blue-tile'
                                                : item == 2 ? 'blue-tile-top'
                                                    : item == 3 ? 'blue-tile-right'
                                                        : item == 4 ? 'blue-tile-bottom'
                                                            : item == 5 ? 'blue-tile-left'
                                                                : item == 6 ? 'v-white-tile-top'
                                                                    : item == 7 ? 'v-white-tile-right'
                                                                        : item == 8 ? 'v-white-tile-bottom'
                                                                            : item == 9 ? 'v-white-tile-left'
                                                                                : 'white-tile'
                                                }`}>
                                            </div>
                                        </div>
                                    })}
                                </div>
                                {tileWords?.[index + 1] == '\n' && <div className=' end-tiles-container float-left'>
                                    <div className='tile overflow-hidden bg-white'></div>
                                    <div className='tile overflow-hidden bg-white'></div>
                                    <div className='tile overflow-hidden bg-white'></div>
                                    <div className='tile overflow-hidden bg-white'></div>
                                    <div className='tile overflow-hidden bg-white'></div>
                                    <div className='tile overflow-hidden bg-white'></div>
                                    <div className='tile overflow-hidden bg-white'></div>
                                </div>}
                            </>
                            )}
                            {tileWords?.length ? <div className='end-tiles-container'>
                                <div className='tile overflow-hidden bg-white'></div>
                                <div className='tile overflow-hidden bg-white'></div>
                                <div className='tile overflow-hidden bg-white'></div>
                                <div className='tile overflow-hidden bg-white'></div>
                                <div className='tile overflow-hidden bg-white'></div>
                                <div className='tile overflow-hidden bg-white'></div>
                                <div className='tile overflow-hidden bg-white'></div>
                            </div> : null}
                        </div>
                    </div>
                }
                {selectedTileType == 'shapes' &&
                    <div className="form-group row mt-4 col-md-8 mx-auto">
                        <div className="col-lg-6">
                            <label className="col-form-label fw-bold ">
                                Name your Blue Tile Art<span className='fw-bold'>*</span>
                            </label>
                            <p>Choose a name that best fits your art</p>
                        </div>
                        <div className="col-lg-6">
                            <input
                                type="input"
                                name="name"
                                defaultValue={editor?.getCurrentContent()?.getPlainText() ?? name}
                                className={`form-control ${validation == 'Missing the name' ? 'border-danger' : ''}`}
                                onChange={e => { setName(e.target.value.trim()); setValidationError(''); setIsNameAvailable(null); }}
                            />
                            {validation == 'Missing the name' ? <p className='text-error'>{validation}</p> : null}
                        </div>
                    </div>}
                {(selectedTileType == 'shapes' || tileWords?.length > 0) &&
                    <div className='border col-md-10 col-xl-8 mx-auto mt-4'>
                        <div className='header border-bottom p-3'>
                            <p className='mb-0 fs-16 fw-600'>Select how you want it</p>
                        </div>
                        <TileDetailsContainer>
                            <div className='merch-grid p-3'>
                                {merchOptions.map((value, index) => {
                                    return (
                                        <div key={`${index}`} className={`merge-container overflow-hidden my-4 rounded bg-white  ${merchandise?.sku == value.sku ? 'border-primary' : 'border'}`} onClick={async () => { await setMerchandise(value); }}>
                                            <p className='mx-2 my-2'>${value.price} {value.name.includes("Original") ? " Per Tile" : value.name.includes("Physical Tiles + Installation") ? " Per Tile + ($219 - $444) Installation Fee" : ""}</p>
                                            <div className={`merge-img-container`}>
                                                {(value.name.includes("Original") || value.name.includes("Physical Tiles + Installation")) ?
                                                    <img src={value.image} alt='tile-image' width={"100%"}  ></img>
                                                    :
                                                    <img src={value.image} alt='tile-image' height={"100%"}  ></img>
                                                }
                                            </div>
                                            <p className='mx-2 my-2'>{value.name.includes("Original") ? "Physical Tiles" : value.name.replace("Blue Tile Project Merchandise - ", "")}</p>
                                        </div>
                                    )
                                })}

                            </div>
                        </TileDetailsContainer>
                    </div>
                }
                {/* {loading ?
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only"></span>
                    </div> :
                    <div className={`${screenProps?.windowSize?.width < 768 ? 'text-center' : null} mt-4 col-md-8`}>
                        {isPatternAvailable === null || isNameAvailable === null ?
                            <p className='text-blue fw-bold mb-0 text-end cursor-pointer' onClick={() => checkAvailability()}>Check if this is taken</p> : null}
                        {isPatternAvailable && isNameAvailable ?
                            <p className={`mb-0 ${screenProps?.windowSize?.width < 768 ? 'text-center' : 'text-end'}`}><BsCheck2Circle color='#2cd071' /> Available</p>
                            : isPatternAvailable === false && isNameAvailable === false ?
                                <p className={`mb-0 ${screenProps?.windowSize?.width < 768 ? 'text-center' : 'text-end'}`}><BsCheck2Circle color='#2cd071' /> Sorry, both the pattern and the name is taken!</p>
                                : isPatternAvailable === false ?
                                    <p className={`mb-0 ${screenProps?.windowSize?.width < 768 ? 'text-center' : 'text-end'}`}><BsCheck2Circle color='#2cd071' /> Sorry, this pattern is taken!</p>
                                    : isNameAvailable === false ?
                                        <p className={`mb-0 ${screenProps?.windowSize?.width < 768 ? 'text-center' : 'text-end'}`}><FcCancel /> Sorry, the name {'"'}{name}{'"'} is taken!</p>
                                        : null
                        }
                    </div>} */}
            </TilesWrapper>
        </>
    )

}